var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaregiversOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6L3.65 14.29C3.65 14.29 4.99 12.36 7.39 12.36C9.79 12.36 10.85 14.2 11.91 14.2H15.06C15.25 14.2 16.51 14.14 16.51 15.11C16.51 16.92 14.89 16.88 11.91 16.88H9.35M2.81 23.09C2.81 23.09 5.45 20.32 7.12 20.32H14.59C16.51 20.32 24 14.52 24 14.52C22.78 12.62 20.76 13.62 20.26 13.87C19.76 14.12 15.93 16.4 15.93 16.4M14.96 3.76L14.22 4.5L13.48 3.76C12.47 2.75 10.83 2.75 9.81 3.76C8.8 4.77 8.8 6.41 9.81 7.43L14.22 11.84L18.63 7.43C19.64 6.42 19.64 4.78 18.63 3.76C17.62 2.75 15.98 2.75 14.96 3.76Z",
    stroke: "#FF43AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiversOn);
export default __webpack_public_path__ + "static/media/caregiversOn.ded8eb90aac1dbf4837e6afcc50ffcb0.svg";
export { ForwardRef as ReactComponent };